import axiosInstance from "../../../../axiosInstance";
import {
  success,
  error,
  info,
  warning,
  error as showError,
} from "../../../../store/notification/actions";

export async function getInventoryReport(
  user_id,
  store_id,
  from_date,
  to_date,
  supplier
) {
  info("Loading report ...");
  return await axiosInstance
    .post("/inventory/getInventoryReport", {
      user_id: user_id,
      store_id: store_id,
      from_date: from_date,
      to_date: to_date,
      supplier: supplier,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Report generated successfully !!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      } else {
        error("Error in report load.");
        return "";
      }
    })
    .catch((err) => {});
}

export async function getInventoryReportByTote(
  user_id,
  store_id,
  from_date,
  to_date,
  supplier,
  tote_no
) {
  info("Loading report ...");
  return await axiosInstance
    .post("/inventory/getInventoryReportByTote", {
      user_id: user_id,
      store_id: store_id,
      from_date: from_date,
      to_date: to_date,
      supplier: supplier,
      tote_no,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Report generated successfully !!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      } else {
        error("Error in report load.");
        return "";
      }
    })
    .catch((err) => {});
}

export async function getReconcillationReport(
  user_id,
  store_id,
  from_date,
  to_date,
  supplier
) {
  info("Loading report ...");
  return await axiosInstance
    .post("/inventory/getReconcillationReport", {
      user_id: user_id,
      store_id: store_id,
      from_date: from_date,
      to_date: to_date,
      supplier: supplier,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Report generated successfully !!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      } else {
        error("Error in report load.");
        return "";
      }
    })
    .catch((err) => {});
}

export async function generateSaleableReturnReconcillationReport(
  user_id,
  store_id,
  supplier,
  supplier_id,
  ra_number
) {
  info("Loading report ...");
  return await axiosInstance
    .post("/inventory/generateSaleableReturnReconcillationReport", {
      user_id: user_id,
      store_id: store_id,
      supplier: supplier,
      supplier_id: supplier_id,
      ra_number: ra_number,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Report generated successfully !!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      } else {
        error("Error in loading report.");
        return "";
      }
    })
    .catch((err) => {});
}

export async function getPhysicalInvenoryReportByQty(
  store_id,
  user_id,
  from_date,
  to_date
) {
  info("Loading report ...");
  return await axiosInstance
    .post("/physicalInventory/getPhysicalInventoryReportByQty", {
      store_id: store_id,
      user_id: user_id,
      from_date: from_date,
      to_date: to_date,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Report generated successfully !!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      } else {
        error("Error in report load.");
        return "";
      }
    })
    .catch((err) => {});
}

export async function getPhysicalInvenoryReportByDeadStock(
  store_id,
  user_id,
  from_date,
  to_date
) {
  info("Loading report ...");
  return await axiosInstance
    .post("/physicalInventory/getPhysicalInventoryReportByDeadStock", {
      store_id: store_id,
      user_id: user_id,
      from_date: from_date,
      to_date: to_date,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Report generated successfully !!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      } else {
        error("Error in report load.");
        return "";
      }
    })
    .catch((err) => {});
}

export async function getPhysicalInvenoryReportByExpiry(
  store_id,
  user_id,
  from_date,
  to_date,
  months,
  expiry_flag
) {
  info("Loading report ...");
  return await axiosInstance
    .post("/physicalInventory/getPhysicalInventoryReportByExpiry", {
      store_id: store_id,
      user_id: user_id,
      from_date: from_date,
      to_date: to_date,
      months: months,
      expiry_flag: expiry_flag,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Report generated successfully !!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      } else {
        error("Error in report load.");
        return "";
      }
    })
    .catch((err) => {});
}

export async function getPhysicalInventoryReportWithoutLotNo(
  user_id,
  store_id,
  from_date,
  to_date
) {
  info("Loading report ...");
  return await axiosInstance
    .post("/inventory/getPhysicalInventoryReportWithoutLotNo", {
      user_id: user_id,
      store_id: store_id,
      from_date: from_date,
      to_date: to_date,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Report generated successfully !!!");
        } else {
          warning("No records found !!!");
        }
        return response.data.data;
      } else {
        error("Error in loading report.");
        return "";
      }
    })
    .catch((err) => {});
}

export async function getCatalogSuppliers(storeId) {
  try {
    info("Loading catalogs...");
    const result = await axiosInstance.post(
      "/ancillary/supplier/getCatalogSuppliers",
      {
        storeId,
      }
    );
    success("Catalogs loaded");
    return { data: result.data.data };
  } catch (error) {
    showError(error.response?.data?.message || error.message);
  }
}
